import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppendDateTimeInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clonedRequest = req.clone({
      headers: req.headers.set('x-datetime', moment(new Date()).format('YYYY-MM-DD HH:mm')),
    });
    return next.handle(clonedRequest);
  }
}
